import React, { useState, useEffect } from 'react';
import { HiChevronUp } from 'react-icons/hi';

const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      className={`fixed z-40 right-7 transition-all duration-500 group ${
        show ? 'bottom-24 md:bottom-24 opacity-100 translate-y-0' : 'bottom-24 md:bottom-24 opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <div className="w-12 h-12 rounded-full bg-dark-800 border border-white/10 flex items-center justify-center shadow-premium-lg group-hover:bg-accent-500 group-hover:border-accent-400 transition-all duration-500 group-hover:-translate-y-1">
        <HiChevronUp className="text-white text-xl" />
      </div>
    </button>
  );
};

export default BackToTop;
